import { IconButton } from '@mui/material';
import FeatherIcon from "feather-icons-react";
import React from 'react';
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { PHRASE_DELETED_FAILED, PHRASE_DELETED_SUCCESS } from '../../helpers/messages';
import Utils from '../../utils';
import { CustomTooltip } from '../../consts';

const DeleteConfirmButton = ({ id, trackerIndex, phraseIndex, data, onSuccess }) => {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(null);
    const showSnackbar = useSnackbar();

    const handleDeleteConfirm = async () => {
        try {
            setIsLoading(true)
            const _data = Object.assign([], data);
            _data[trackerIndex].phrases.splice(phraseIndex, 1);
            await Utils.genericMutation("updateCompany", {
                id,
                trackers: JSON.stringify(_data),
            });
            setOpen(false);
            setIsLoading(false);
            onSuccess(_data);
            showSnackbar(PHRASE_DELETED_SUCCESS);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            showSnackbar(PHRASE_DELETED_FAILED, "error");
        }
    };

    const renderConfirm = () => {
        return (<ConfirmDialog
            open={open}
            loading={isLoading}
            onClose={setOpen}
            onConfirm={handleDeleteConfirm}
            title="Confirm Delete"
            okText="Delete"
            message={`Are you sure you want to delete this phrase?`}
        />)
    }

    const handleClick = (e) => {
        setOpen(true);
    }

    return (
        <>
            {renderConfirm()}
            <CustomTooltip title={"Delete"}>
                <IconButton
                    aria-label="Delete"
                    size="small"
                    color="inherit"
                    onClick={handleClick}
                    disabled={true} // VOC-199 DISABLED FOR DEMO
                >
                    <FeatherIcon icon="trash-2" size={20} />
                </IconButton>
            </CustomTooltip>
        </>
    )
}

export default DeleteConfirmButton